import { Box } from '@material-ui/core';
import React from 'react';
import { ProgressBarStyles } from '../../styles/ProgressBar';
import { useTranslation } from 'react-i18next';

const ProgressBar = ({
  attempted,
  total,
  setShowViewAll,
  isViewAllPage,
}: {
  attempted?: number;
  total?: number;
  setShowViewAll?: React.Dispatch<React.SetStateAction<boolean>>;
  isViewAllPage?: boolean;
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = ProgressBarStyles();

  let progress = 0;
  let progressCSS = { width: '0' };

  if (attempted && total && attempted > 0) {
    progress = Math.ceil((attempted * 100) / total);
    progress = progress > 100 ? 100 : progress;
    progressCSS = { width: `${progress}%` };
  }

  return (
    <div className={classes.progressBox}>
      <Box className={classes.progress} aria-label={`Progress Bar ${progress} percent`} aria-required="true">
        <div className={classes.progressContainer}>
          <div className={classes.progressBg}></div>
          <div className={classes.progressBar} data-testid="progress-bar" style={progressCSS}></div>
        </div>
        <div className={classes.progressCount}>
          <div className={classes.labelLt}>{progress}%</div>
          {!isViewAllPage && (
            <div
              className={classes.labelRt}
              onClick={(): void => {
                setShowViewAll && setShowViewAll(true);
              }}>
              <span role="link" aria-label={t('viewAll')}>
                {t('viewAll')}
              </span>
            </div>
          )}
        </div>
      </Box>
    </div>
  );
};

export default ProgressBar;
